import { ActivityOpinion } from ".";
import IAttivita, { exampleAttivita } from "./IAttivita";

export default interface IScheda {
    Id: number;
    Id_Osservazione: number;
    Id_Attivita: number;
    Giudizio: ActivityOpinion | null;
    Testo: string | null;
    Strategia: string | null;
    Creation: string;
    Timestamp: string;

    //* NotMapped
    Attivita: IAttivita;
}

export const exampleScheda: IScheda = {
    Id: 0,
    Id_Osservazione: 0,
    Id_Attivita: 0,
    Giudizio: null,
    Testo: null,
    Strategia: null,
    Creation: '',
    Timestamp: '',

    Attivita: exampleAttivita,
}
